import React, { useEffect, useRef } from 'react';
import { LeftIconWrapper, Option, OptionWrapper, OptionsMenuInnerWrapper, OptionsMenuWrapper } from './subcomponents';
import { isOptionEqual } from './helpers';
const OptionsMenu = ({ menuPosition, options, selectedOption, focusedOption, onOptionClick, id, ariaLabelledBy }) => {
    const optionsRefs = useRef([]);
    const addOptionRef = (option, index) => {
        if (option) {
            optionsRefs.current[index] = option;
        }
    };
    useEffect(() => {
        var _a, _b;
        const currFocusedOptionIndex = options.findIndex(option => isOptionEqual(option, focusedOption));
        (_a = optionsRefs.current[currFocusedOptionIndex]) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            block: 'nearest'
        });
        (_b = optionsRefs.current[currFocusedOptionIndex]) === null || _b === void 0 ? void 0 : _b.focus();
    }, [focusedOption, options]);
    return (React.createElement(OptionsMenuWrapper, { placement: menuPosition },
        React.createElement(OptionsMenuInnerWrapper, { id: `${id}-options-inner-wrapper`, role: "listbox", "aria-labelledby": ariaLabelledBy }, options.map((option, index) => {
            const isSelectedOptionEqual = isOptionEqual(selectedOption, option);
            const isFocusedOptionEqual = isOptionEqual(focusedOption, option);
            return (React.createElement(OptionWrapper, { hasIcon: !!option.icon, tabIndex: -1, "aria-label": option.label, "data-cy": option.dataCy, "data-type": option.dataType, "data-object": option.dataObject, "data-reason": option.dataReason, selected: isSelectedOptionEqual, focused: isFocusedOptionEqual, onClick: () => onOptionClick(option), "aria-selected": isSelectedOptionEqual, id: `${id}-option-${index}`, key: `${id}-${option.label}`, className: "Select__option--open", role: "option", ref: (el) => addOptionRef(el, index) }, option.element || (React.createElement(React.Fragment, null,
                option.icon && (React.createElement(LeftIconWrapper, null, option.icon)),
                React.createElement(Option, null, option.label)))));
        }))));
};
export default OptionsMenu;
